export type ComboBoxDefaultOption = {
  label: string
  value: string
  disabled?: boolean
}

// custom option should be an object
// but not an array or a string (both inherit object type)
type ComboBoxCustomOption = Exclude<
  {
    length?: never
    [key: string]: any
  },
  string
>

export type ComboBoxOption = string | ComboBoxDefaultOption | ComboBoxCustomOption

export type ComboBoxGroupedOption<T> = {
  group: string
  options: T[]
}

export type ComboBoxGetOptionProperty<T> = (option: T) => string

export type ComboBoxVirtualizationOptions = {
  /**
   * Number of rows that should be visible in the UI
   */
  rowsVisible?: number
  /**
   * Height of one row
   */
  rowHeight?: number
  /**
   *  Number of items outside of the visible "window" to render at all times
   */
  overscanCount?: number
}

export const OPTION_TYPE_CREATE = 'OPTION_TYPE_CREATE'

export const getOptionLabelDefault = <T>(option: T) => {
  const sanitize = (val: string) => val.replace(/\n|\r/g, ' ')
  let label = ''
  if (typeof option === 'string') label = option
  else if ((option as any).label) label = (option as any).label
  else label = (option as any)[Object.keys(option as Object)[0]]
  return sanitize(label)
}

export const getOptionValueDefault = <T>(option: T) => {
  if (typeof option === 'string') return option
  if ((option as any).value) return (option as any).value
  return (option as any)[Object.keys(option as Object)[0]]
}

export const getOptionDisabled = <T>(option: T) => {
  if ((option as any)?.disabled) return (option as any)?.disabled
  return false
}

export const isOptionSelected = <T>(selectedItems: T[], option: T, getOptionLabel: Function): boolean => {
  if (typeof option === 'string') return selectedItems.includes(option)
  return selectedItems.find((item) => getOptionLabel(item) === getOptionLabel(option)) !== undefined
}
